import automationSliceReducer from './slices/Automation.slice.js';
import canvasSliceReducer from './slices/Canvas.slice.js';
import dataSliceReducer from './slices/Data.slice.js';
import guiSliceReducer from './slices/Gui.slice.js';
import irrigationSliceReducer from './slices/Irrigation.slice.js';
import materialListSliceReducer from './slices/MaterialList.slice.js';
import pipelineSliceReducer from './slices/Pipeline.slice.js';
import roboticMowerSlice from './slices/RoboticMower.slice.js';
import sprinklerSliceReducer from './slices/Sprinkler.slice.js';

const coreReducer = {
  data: dataSliceReducer,
  canvas: canvasSliceReducer,
  gui: guiSliceReducer,
  pipeline: pipelineSliceReducer,
  sprinkler: sprinklerSliceReducer,
  irrigation: irrigationSliceReducer,
  automation: automationSliceReducer,
  roboticMower: roboticMowerSlice,
  materialList: materialListSliceReducer,
};

export default coreReducer;
